import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import WidgetNav from './WidgetNav';

const WidgetNavProvider = (props) => {
  const {
    Analytics, backPath, pageContext, search, showBack, showNav, showProfileMenu, navSubTitle, navTitle, navVenueName,
  } = props;
  const navigate = useNavigate();
  return (
    showNav && (
      <div className="resy-nav">
        <WidgetNav
          Analytics={Analytics}
          backPath={backPath}
          navigate={navigate}
          pageContext={pageContext}
          search={search}
          showBack={showBack}
          showProfileMenu={showProfileMenu}
          subTitle={navSubTitle}
          title={navTitle}
          venueName={navVenueName}
        />
      </div>
    )
  );
};

WidgetNavProvider.propTypes = {
  Analytics: PropTypes.shape({}).isRequired,
  backPath: PropTypes.string.isRequired,
  navSubTitle: PropTypes.string.isRequired,
  navTitle: PropTypes.string.isRequired,
  navVenueName: PropTypes.string.isRequired,
  pageContext: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
  showBack: PropTypes.bool.isRequired,
  showNav: PropTypes.bool.isRequired,
  showProfileMenu: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ resyRouter }) => {
  const {
    backPath, pageContext, search, showBack, showNav, showProfileMenu, navSubTitle, navTitle, navVenueName,
  } = resyRouter;
  return {
    backPath,
    pageContext,
    search,
    showBack,
    showNav,
    showProfileMenu,
    navSubTitle,
    navTitle,
    navVenueName,
  };
};

export { WidgetNavProvider as ComponentUnderTest, mapStateToProps };
export default connect(mapStateToProps)(WidgetNavProvider);
